import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';

export default {
    id: 'credit-memos',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.text,
        },
        customerId: {
            type: FILTER_TYPES.text,
        },
        // todo: Change FILTER_SOURCE_TYPE of "type", "status","reason" filters to FILTER_SOURCE_TYPES.definitions (https://jira.ilabsinc.com/browse/GWY-12050)
        type: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: ['adjustment', 'refundable'],
            },
        },
        status: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: ['applied', 'not-applied', 'partially-applied', 'refund-due', 'refund-failed', 'refunded', 'voided'],
            },
        },
        reason: {
            type: FILTER_TYPES.enum,
            options: {
                source: FILTER_SOURCE_TYPES.enum,
                enum: ['chargeback', 'customer-credit', 'order-cancellation', 'order-change', 'other', 'product-unsatisfactory', 'return', 'waiver', 'write-off'],
            },
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
        currency: {
            type: FILTER_TYPES.text,
        },
        revision: {
            type: FILTER_TYPES.numeric,
        },
    },
};
